var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.demoLogin)?_c('DemoLogin'):(_vm.kerberosLogin)?_c('KerberosLogin'):(_vm.keycloakLogin)?_c('KeycloakLogin'):_c('div',[_vm._v("Fehler, konnte keine Authentifizierungsmethode ermitteln")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }